import Quote from './Quote'

export default Quote
